module.exports = require("repl");


//////////////////
// WEBPACK FOOTER
// external "repl"
// module id = 1224
// module chunks = 0